import React, { useEffect, useState } from 'react'
import { Alert, Button, Checkbox, Drawer, Form, Input, message, notification, Popconfirm, Tag } from 'antd'
import {
    PlusOutlined,
    SaveOutlined,
    EditOutlined,
    DeleteOutlined,
} from '@ant-design/icons';
import Container from '../../../components/Container'
import Main from '../../../components/Main'
import PageHeader from '../../../components/PageHeader'
import AgoraTable from '../../../components/Table';
import { useAuthUser } from 'react-auth-kit';
import axios from 'axios';

function Language() {
    const auth = useAuthUser()
    const [languageForm] = Form.useForm();
    const [state, setState] = useState({
        gvLanguageLoading: false,
        gvLanguage: [],
        formOpen: false,
        formType: "Add",
        btnSubmitLoading: false,
        btnSubmitResStatus: "",
        btnSubmitResMsg: "",
        btnDeleteLoading: false,
    })
    const handleSetState = (newState) => {
        setState(prevState => ({
            ...prevState,
            ...newState,
        }))
    }
    useEffect(() => {
        getLanguagePageLoad()
        // eslint-disable-next-line
    }, [])
    const getLanguagePageLoad = () => {
        handleSetState({ gvLanguageLoading: true })
        axios.get(`/Language/PageLoad`).then(res => {
            let resData = res.data
            if (resData.Status === "True") {
                handleSetState({
                    gvLanguageLoading: false,
                    gvLanguage: resData.Data.gvLanguage
                })
                return resData.Data
            } else {
                message.error(resData.Message)
            }
        }).catch(error => {
            console.log(error)
            message.error(error.message)
        })
    }
    const handleOnFinishLanguage = (formData) => {
        handleSetState({ btnSubmitLoading: true })
        if (state.formType === "Add") {
            axios.post(`/Language/Create`, {
                languageDesc: formData.languageDesc,
                languageDefault: formData.languageDefault,
                createdBy: auth().userId,
            }).then(res => {
                let resData = res.data
                if (resData.Status === "True") {
                    handleSetState({
                        formOpen: false,
                        btnSubmitLoading: false
                    });
                    getLanguagePageLoad();
                    notification.success({
                        message: "Successful",
                        description: resData.Message
                    });
                } else {
                    handleSetState({
                        btnSubmitLoading: false,
                        btnSubmitResStatus: resData.Status,
                        btnSubmitResMsg: resData.Message,
                    });
                }
            }).catch(error => {
                console.log(error);
                message.error(error.message);
            })
        } else if (state.formType === "Edit") {
            axios.post(`/Language/Update`, {
                languageId: formData.languageId,
                languageDesc: formData.languageDesc,
                languageDefault: formData.languageDefault,
                modifiedBy: auth().userId,
            }).then(res => {
                let resData = res.data
                if (resData.Status === "True") {
                    handleSetState({
                        formOpen: false,
                        btnSubmitLoading: false
                    });
                    getLanguagePageLoad();
                    notification.success({
                        message: "Successful",
                        description: resData.Message
                    });
                } else {
                    handleSetState({
                        btnSubmitLoading: false,
                        btnSubmitResStatus: resData.Status,
                        btnSubmitResMsg: resData.Message,
                    });
                }
            }).catch(error => {
                console.log(error);
                message.error(error.message);
            })
        }

    }
    const handleOnDeleteLanguage = () => {
        handleSetState({ btnDeleteLoading: true })
        axios.post(`/Language/Delete`, {
            languageId: languageForm.getFieldValue("languageId"),
            modifiedBy: auth().userId,
        }).then(res => {
            let resData = res.data
            if (resData.Status === "True") {
                handleSetState({
                    formOpen: false,
                    btnDeleteLoading: false
                });
                getLanguagePageLoad();
                notification.success({
                    message: "Successful",
                    description: resData.Message
                });
            } else {
                handleSetState({
                    btnDeleteLoading: false,
                    btnSubmitResStatus: resData.Status,
                    btnSubmitResMsg: resData.Message,
                });
            }
        }).catch(error => {
            console.log(error);
            message.error(error.message);
        })

    }

    const isAllowToManage = () => {
        if (auth().role === "Admin") {
            return true
        }
        return false;
    }

    return (
        <Main listBreadcrumb={[
            { key: "1", title: "Maintenance" },
            { key: "2", title: "Library" },
            { key: "3", title: "Language" },
        ]}>
            <Container>
                <PageHeader title="Language" subtitle="List of language details.">
                    {isAllowToManage() &&
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => {
                                languageForm.resetFields();
                                handleSetState({
                                    formOpen: true,
                                    formType: "Add",
                                })
                            }}
                        >
                            New Language
                        </Button>
                    }
                </PageHeader>
                <AgoraTable
                    loading={state.gvLanguageLoading}
                    dataSource={state.gvLanguage}
                    rowKey="languageId"
                    columns={[
                        {
                            title: 'Language Name',
                            dataIndex: 'languageDesc',
                            key: 'languageDesc',
                            dataType: "text",
                            render: (text, record) => <div className="i-x-space-between">
                                <div className='i-x-left i-y-center'>
                                    {text || "-"}
                                    {record.languageDefault && <Tag color="blue" style={{ marginLeft: "10px" }}>Default</Tag>}
                                </div>
                                <div className="i-x-right">
                                    {isAllowToManage() &&
                                        <Button className="table-btn edit" size="small" style={{ marginRight: "10px" }}
                                            onClick={() => {
                                                languageForm.setFieldsValue({
                                                    languageId: record.languageId,
                                                    languageDesc: record.languageDesc,
                                                    languageDefault: record.languageDefault,
                                                });
                                                handleSetState({
                                                    formOpen: true,
                                                    formType: "Edit",
                                                })
                                            }}
                                        ><EditOutlined /> Edit</Button>
                                    }
                                </div>
                            </div>,
                        },
                    ]}
                />
            </Container>
            <Drawer title={`${state.formType} Language`}
                width={window.innerWidth > 500 ? 500 : window.innerWidth - 80}
                open={state.formOpen}
                extra={
                    <Button type="primary"
                        loading={state.btnSubmitLoading}
                        onClick={() => languageForm.submit()}
                        icon={state.formType === "Add" ? <PlusOutlined /> : <SaveOutlined />}
                    >
                        {state.formType === "Add" ? "Add" : "Update"}
                    </Button>
                }
                onClose={() => {
                    languageForm.resetFields()
                    handleSetState({
                        formType: "Add",
                        formOpen: false,
                        btnSubmitResStatus: "",
                        btnSubmitResMsg: "",
                    })
                }}
            >
                <div className="i-y-100 i-y-space-between">
                    <Form
                        form={languageForm}
                        name="language-form"
                        layout="vertical"
                        size="middle"
                        requiredMark={false}
                        onFinish={handleOnFinishLanguage}
                    >
                        {state.btnSubmitResStatus !== ""
                            && <Alert type="error" showIcon style={{ margin: "0px 25px 20px 0px" }}
                                message={state.btnSubmitResMsg}
                            />
                        }
                        <Form.Item hidden={true} name="languageId" ></Form.Item>
                        <Form.Item
                            label="Language Name"
                            name="languageDesc"
                            tooltip="This is a required field"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter language name!',
                                },
                            ]}
                        >
                            <Input placeholder='e.g., English' />
                        </Form.Item>
                        <Form.Item name="languageDefault" valuePropName="checked" noStyle>
                            <Checkbox>Set as Default</Checkbox>
                        </Form.Item>
                    </Form>
                    {state.formType === "Edit"
                        ? <div>
                            <Popconfirm
                                title="Delete language"
                                description="Are you sure to delete this language?"
                                onConfirm={handleOnDeleteLanguage}
                                okText="Yes"
                                okType="danger"
                            >
                                <Button type="primary" danger block loading={state.btnDeleteLoading}
                                    icon={<DeleteOutlined />}
                                >Delete Language</Button>
                            </Popconfirm>
                        </div>
                        : ""
                    }
                </div>
            </Drawer>
        </Main>
    )
}

export default Language